module.exports = __webpack_public_path__ + "static/img/shl_small_baskeball_level_3.be1db9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_small_baskeball_level_3.png
// module id = 4Ckm
// module chunks = 5